export default __webpack_public_path__ + "static/media/sector-courier.c0c202d2.png";